import { loadUser, loadDay } from 'store/queries/user';
import { get } from 'lodash';

function reset() {
  return {
    id: null,
    application_id: null,
    created_at: null,
    device: {},
    location: {},
    locations: [],
    segments: [],
    day: null,
    event_history: [],
    moment_history: [],
    custom_event_history: [],
  };
}

const state = reset();

const actions = {
  /**
   * Load a user
   *
   * @param {string}  id    A user id
   * @param {string}  day   A date in YYYY-MM-DD format
   * @returns {Promise}
   */
  loadUser({ state, commit, rootState }, { id, day }) {
    if (id !== state.id) {
      commit('reset');
    }

    return loadUser({ id, day }).then(res => {
      const user = get(res, 'body.data.user');

      if (!user) {
        commit('reset');
        throw new Error('User not found.');
      }

      commit('user', user);
      commit('day', day);

      return user;
    });
  },

  loadDay({ state, commit }, day) {
    const { id } = state;
    loadDay({ id, day }).then(res => {
      const user = get(res, 'body.data.user');

      if (!user) {
        commit('reset');
        throw new Error('User not found.');
      }

      commit('day', day);
      commit('history', user);
    });
  },
};

const mutations = {
  reset(state) {
    Object.assign(state, reset());
  },

  user(state, value) {
    Object.assign(state, value);
  },

  day(state, value) {
    state.day = value;
  },

  history(state, value) {
    Object.assign(state, value);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
